import {createAction} from "@reduxjs/toolkit";
import {PipelineFlowSearchCriteria} from "@ots-frontend/ots-data";

export const setUIPipelineFlowSearchFilter = createAction<PipelineFlowSearchCriteria>("ots-ui/pipeline-flow/setSearchFilter");
